import { render, staticRenderFns } from "./TaskTitle.vue?vue&type=template&id=0d8dd190&scoped=true&"
import script from "./TaskTitle.vue?vue&type=script&lang=js&"
export * from "./TaskTitle.vue?vue&type=script&lang=js&"
import style0 from "./TaskTitle.vue?vue&type=style&index=0&id=0d8dd190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8dd190",
  null
  
)

export default component.exports